import { ROUTES_NAMES } from '@/constants';
import { RouteRecordRaw } from 'vue-router';
import Error from '@/views/Error.vue';

const errorRoute: RouteRecordRaw = {
  path: '/error',
  name: ROUTES_NAMES.error,
  component: Error
};

export default errorRoute;
